export default __webpack_public_path__ + "locales/sk/UploadPanel.json?hash=91f10af832ba07acaa415a0a50aab3da";